import { actingOwner } from "../../http/foyer";
import {
  PermissionGate,
  type PermissionGateProps,
  type PlaceRef,
} from "../../auth/access";

/** The content owner the supplier shell acts for, where its owner routes are checked. */
export function ownerPlace(): PlaceRef {
  return { companyId: actingOwner() ?? "" };
}

export function OwnerGate(props: Omit<PermissionGateProps, "place">) {
  return <PermissionGate {...props} place={ownerPlace()} />;
}
